<claas-header
  [(isMenuOpen)]="expanded"
  [showMenuIconButton]="true"
  [title]="'Partner Office'"
  [softwareStatusOverlay]="softwareStatusLabel"
  [logoInteractive]="true"
  (logoClicked)="onLogoClicked($event)"
>
  <ng-container ngProjectAs="content-mid"> </ng-container>

  <ng-container ngProjectAs="content-right">
    <div style="display: flex; align-items: center; gap: 8px">
      <claas-icon-button
        [icon]="{ iconId: '648467', namespace: 'cc', iconStyle: 'bold' }"
        ariaLabel="Applications"
        routerLink="/applications"
      />
      <claas-user-overlay />
    </div>
  </ng-container>
</claas-header>
<claas-navigation
  [class.cms-content]="isCmsRoute()"
  [menuItems]="menuItems() ?? []"
  [applicationHasRouterOutlet]="true"
  [(expanded)]="expanded"
>
  <main
    id="top"
    class="mat-typography main"
    [class.pia]="isPiaRoute()"
    claasScrollAnchor
  >
    <router-outlet></router-outlet>
    <div class="pia-overlay"></div>
  </main>
  <claas-scroll-to-top></claas-scroll-to-top>
</claas-navigation>
<app-loading-progress-bar></app-loading-progress-bar>
